<template>
    <!-- Content -->
    <section id="content" class="content terms-cont">
        <!-- Content Header -->
        <div class="content-header sub-visual">
            <div class="sub-visual-bg sub-visual-auto-bg"></div>
            <div class="in-sec">
                <!-- 고도화 Ver1 : br추가 -->
                <div class="tit-wrap centered-c">
                    <h2 class="tit-h2" v-html="$t('sdp.menu.device.auto_terms_condition')"></h2>
                </div>
            </div>
        </div>
        <!-- //Content Header -->

        <!-- Content Body -->
        <div class="content-body">
            <!-- 탭전체영역 -->
            <!-- 고도화 ver2 : 속성 id, labelledby 연결 -->
            <!-- 2024.06.21 송준형 : REQSDP-5357 - PC Mall 웹접근성 심사결과대응 2차 -->
            <div class="terms-auto-list-wrap tab-type4-wrap in-sec">
                <!-- 메인탭 -->
                <div class="terms-version"></div>
                <nav v-show="plfmCode == 'A23H'" class="tab-nav tab-terms-auto tab-change">
                    <ul role="tablist">
                        <li role="presentation" class="is-active"><a @click="getDeviceTerms(tab1Type)" href="#tabContentTerms1" role="tab" id="tabNavTerms1" aria-controls="tabContentTerms1" aria-selected="true"><span class="tit depth">{{ $t("sdp.menu.device.menutop1") }}</span></a><!-- 2025.04.23 Mod 웹접근성 대응 -->
                            <div :id="termsIds.tabContentTerms1" aria-labelledby="tabNavTerms1" class="tab-content tab-col is-active" v-show="loadingYn == 'N'">
                                <nav class="tab-nav tab-change tab-sync tab-type5">
                                    <ul role="tablist">
                                        <template v-for="title in termsTitle"><li v-if="title.termsMgtTpCode == 'S_LGN'" role="presentation" class="is-active"><a @click="getDeviceTerms('S_LGN')" href="#tabContentTerms11" role="tab" :id="termsIds.tabNavTerms11" aria-controls="tabContentTerms11" aria-selected="true"><span class="tit" v-html="title.termsTpName"></span></a></li></template>
                                        <template v-for="title in termsTitle"><li v-if="title.termsMgtTpCode == 'S_DSC'" role="presentation"><a @click="getDeviceTerms('S_DSC')" href="#tabContentTerms12" role="tab" aria-controls="tabContentTerms12" :id="termsIds.tabNavTerms12" aria-selected="false"><span class="tit" v-html="title.termsTpName"></span></a></li></template>
                                    </ul>
                                </nav>
                            </div>
                        </li>
                        <li role="presentation"><a @click="getDeviceTerms(tab2Type)" href="#tabContentTerms2" role="tab" id="tabNavTerms2" aria-controls="tabContentTerms2" aria-selected="false"><span class="tit depth">{{ $t("sdp.menu.device.menutop2") }}</span></a><!-- 2025.04.23 Mod 웹접근성 대응 -->
                            <div :id="termsIds.tabContentTerms2" aria-labelledby="tabNavTerms2" class="tab-content tab-col" v-show="loadingYn == 'N'">
                                <nav class="tab-nav tab-change tab-sync tab-type5">
                                    <ul role="tablist">
                                        <template v-for="title in termsTitle"><li v-if="title.termsMgtTpCode == 'S_SVC'" role="presentation"><a @click="getDeviceTerms('S_SVC')" href="#tabContentTerms21" role="tab" :id="termsIds.tabNavTerms21" aria-controls="tabContentTerms21" aria-selected="true"><span class="tit" v-html="title.termsTpName"></span></a></li></template>
                                        <template v-for="title in termsTitle"><li v-if="title.termsMgtTpCode == 'S_PRV'" role="presentation"><a @click="getDeviceTerms('S_PRV')" href="#tabContentTerms22" role="tab" :id="termsIds.tabNavTerms22" aria-controls="tabContentTerms22" aria-selected="false"><span class="tit" v-html="title.termsTpName"></span></a></li></template>
                                        <template v-for="title in termsTitle"><li v-if="title.termsMgtTpCode == 'S_PRY'" role="presentation"><a @click="getDeviceTerms('S_PRY')" href="#tabContentTerms23" role="tab" :id="termsIds.tabNavTerms23" aria-controls="tabContentTerms23" aria-selected="false"><span class="tit" v-html="title.termsTpName"></span></a></li></template>
                                    </ul>
                                </nav>
                            </div>
                        </li>
                        <!--<li role="presentation"><a @click="getDeviceTerms(tab3Type)" href="#tabContentTerms3" role="tab" id="tabNavTerms3" aria-controls="tabContentTerms3" aria-selected="false"><span class="tit">{{ $t("sdp.menu.device.menutop3") }}</span></a>-->
                            <!--<div :id="termsIds.tabContentTerms3" aria-labelledby="tabNavTerms3" class="tab-content tab-col" v-show="loadingYn == 'N'">-->
                                <!--<nav class="tab-nav tab-change tab-sync tab-type5">-->
                                    <!--<ul v-if="deviceTerms.cntryCode == 'KR'" role="tablist">-->
                                        <!--<template v-for="title in termsTitle"><li v-if="title.termsMgtTpCode == 'S_PRC'" role="presentation"><a @click="getDeviceTerms('S_PRC')" href="#tabContentTerms31" role="tab" :id="termsIds.tabNavTerms31" aria-controls="tabContentTerms31" aria-selected="true"><span class="tit" v-html="title.termsTpName"></span></a></li></template>-->
                                        <!--<template v-for="title in termsTitle"><li v-if="title.termsMgtTpCode == 'S_PRD'" role="presentation"><a @click="getDeviceTerms('S_PRD')" href="#tabContentTerms32" role="tab" :id="termsIds.tabNavTerms32" aria-controls="tabContentTerms32" aria-selected="false"><span class="tit" v-html="title.termsTpName"></span></a></li></template>-->
                                        <!--<template v-for="title in termsTitle"><li v-if="title.termsMgtTpCode == 'S_VDC'" role="presentation"><a @click="getDeviceTerms('S_VDC')" href="#tabContentTerms33" role="tab" :id="termsIds.tabNavTerms33" aria-controls="tabContentTerms33" aria-selected="false"><span class="tit" v-html="title.termsTpName"></span></a></li></template>-->
                                        <!--<template v-for="title in termsTitle"><li v-if="title.termsMgtTpCode == 'S_VDD'" role="presentation"><a @click="getDeviceTerms('S_VDD')" href="#tabContentTerms34" role="tab" :id="termsIds.tabNavTerms34" aria-controls="tabContentTerms34" aria-selected="false"><span class="tit" v-html="title.termsTpName"></span></a></li></template>-->
                                    <!--</ul>-->
                                    <!--<ul v-else role="tablist"></ul>-->
                                <!--</nav>-->
                            <!--</div>-->
                        <!--</li>-->
                    </ul>
                </nav>
                <!-- //서브탭 -->

                <div class="section-body" v-if="loadingYn == 'Y'">
                    <div class="loading-wrap">
                        <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
                    </div>
                </div>
                <div class="tab-body" v-else>
                    <!-- Tab11 -->
                    <div id="tabContentTerms11" class="tab-content is-active" aria-labelledby="tabNavTerms11">
                        <h3 class="blind blind-labelledby dv-pc-only" data-labelledby="tabNavTerms11"></h3>
                        <div id="termsSec11" class="terms-sec-wrap">
                            <div class="terms-sec" v-html="deviceTerms.termsCntt"></div>
                        </div>
                    </div>
                    <!-- //Tab11 -->
                    <!-- Tab12 -->
                    <div id="tabContentTerms12" class="tab-content" aria-labelledby="tabNavTerms12">
                        <h3 class="blind blind-labelledby dv-pc-only" data-labelledby="tabNavTerms12"></h3>
                        <div id="termsSec12" class="terms-sec-wrap">
                            <div class="terms-sec" v-html="deviceTerms.termsCntt"></div>
                        </div>
                    </div>
                    <!-- //Tab12 -->
                    <!-- Tab21 -->
                    <div id="tabContentTerms21" class="tab-content" aria-labelledby="tabNavTerms21">
                        <h3 class="blind blind-labelledby dv-pc-only" data-labelledby="tabNavTerms21"></h3>
                        <div id="termsSec21" class="terms-sec-wrap">
                            <div class="terms-sec" v-html="deviceTerms.termsCntt"></div>
                        </div>
                    </div>
                    <!-- //Tab21 -->
                    <!-- Tab22 -->
                    <div id="tabContentTerms22" class="tab-content" aria-labelledby="tabNavTerms22">
                        <h3 class="blind blind-labelledby dv-pc-only" data-labelledby="tabNavTerms22"></h3>
                        <div id="termsSec22" class="terms-sec-wrap">
                            <div class="terms-sec" v-html="deviceTerms.termsCntt"></div>
                        </div>
                    </div>
                    <!-- //Tab22 -->
                    <!-- Tab23 -->
                    <div id="tabContentTerms23" class="tab-content" aria-labelledby="tabNavTerms23">
                        <h3 class="blind blind-labelledby dv-pc-only" data-labelledby="tabNavTerms23"></h3>
                        <div id="termsSec23" class="terms-sec-wrap">
                            <div class="terms-sec" v-html="deviceTerms.termsCntt"></div>
                        </div>
                    </div>
                    <!-- //Tab23 -->
                    <!-- Tab31 -->
                    <!--<div id="tabContentTerms31" class="tab-content" aria-labelledby="tabNavTerms31">-->
                        <!--<h3 class="blind blind-labelledby dv-pc-only" data-labelledby="tabNavTerms31"></h3>-->
                        <!--<div id="termsSec31" class="terms-sec-wrap">-->
                            <!--<div class="terms-sec" v-html="deviceTerms.termsCntt"></div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!-- //Tab31 -->
                    <!-- Tab32 -->
                    <!--<div id="tabContentTerms32" class="tab-content" aria-labelledby="tabNavTerms32">-->
                        <!--<h3 class="blind blind-labelledby dv-pc-only" data-labelledby="tabNavTerms32"></h3>-->
                        <!--<div id="termsSec32" class="terms-sec-wrap">-->
                            <!--<div class="terms-sec" v-html="deviceTerms.termsCntt"></div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!-- //Tab32 -->

                    <div v-if="plfmCode != 'A23H'" class="terms-sec-wrap">
                        <div class="terms-sec">
                            <div class="header-wrap" v-html="deviceTerms.termsCntt"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //탭전체영역 -->

            <!-- 팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
            <div v-show="cntryCode == 'FR'">
                <TermsPop></TermsPop>
            </div>
            <!-- //팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->

        </div>
        <!-- //Content Body -->
    </section>
    <!-- //Content -->
</template>

<script>
    import qs from "qs";
    import TermsPop from '@/components/terms/TermsPop';

    export default {
        name: "TermsAuto",
        components: {
            TermsPop //PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중
        },
        data() {
            return {
                termsTitle: [],
                deviceTerms: {},
                gdprFlag: "",
                tab1Type: "S_LGN",
                tab2Type: "S_SVC",
                tab3Type: "",
                plfmCode: "A23H",
                loadingYn: "Y",
                termsIds: {
                    tabContentTerms1: "tabContentTerms1",
                    tabContentTerms2: "tabContentTerms2",
                    tabContentTerms3: "tabContentTerms3",
                    tabNavTerms11: "tabNavTerms11",
                    tabNavTerms12: "tabNavTerms12",
                    tabNavTerms21: "tabNavTerms21",
                    tabNavTerms22: "tabNavTerms22",
                    tabNavTerms23: "tabNavTerms23",
                    tabNavTerms24: "tabNavTerms24",
                    tabNavTerms25: "tabNavTerms25",
                    tabNavTerms31: "tabNavTerms31",
                    tabNavTerms32: "tabNavTerms32",
                    tabNavTerms33: "tabNavTerms33",
                    tabNavTerms34: "tabNavTerms34",
                    tabNavTerms35: "tabNavTerms35",
                    tabNavTerms36: "tabNavTerms36",
                    tabNavTerms37: "tabNavTerms37"
                }
            }
        },
        methods: {
            track () {
                console.log('@@@@ track:', this.$router.currentRoute.path);
                this.$ga.page(this.$router.currentRoute.path)
            },
            getDeviceTerms(type) {
                const vm = this;
                vm.loadingYn = "Y";
                ui.loading.open();

                var termsMgtTpCode = "";
                var netcastYn = "N";
                // if(vm.plfmCode == "GP4H" || vm.plfmCode == "NC4H" || vm.plfmCode == "NC5U") {
                //     netcastYn = "Y";
                // }

                // if(type == "PLFM") { // REQSDP-2669 - [pcmall] pc website 약관연동 update 반영요청 件 : W23O 추가
                //     if(vm.plfmCode == "W17H" || vm.plfmCode == "W18H" || vm.plfmCode == "W19H" || vm.plfmCode == "W20H" || vm.plfmCode == "W21U" || vm.plfmCode == "W22H" || vm.plfmCode == "W23O") {
                //         termsMgtTpCode = "S_LGN";
                //     } else {
                //         if(vm.deviceTerms.cntryCode == "KR") {
                //             termsMgtTpCode = "S_PRT";
                //         } else {
                //             termsMgtTpCode = "S_PRG";
                //         }
                //     }
                //     $("#tabNavTerms1").trigger("click");
                //     $("#tabNavTerms11").trigger("click");
                // } else if(type == "") {
                //     if(vm.deviceTerms.cntryCode == "KR") {
                //         termsMgtTpCode = "S_ADC";
                //     } else if (vm.gdprFlag == "Y") {
                //         termsMgtTpCode = "S_VNG";
                //     } else {
                //         termsMgtTpCode = "S_ADG";
                //     }
                // } else {
                //     termsMgtTpCode = type;
                // }

                if(type != "") {
                    termsMgtTpCode = type;
                }

                const params = {
                    termsMgtTpCode : termsMgtTpCode,
                    plfmCode : vm.plfmCode,
                    netcastYn : netcastYn
                };

                this.$axios.post("/api/terms/retrieveDeviceTerms.ajax",
                    qs.stringify(params)).then((result) => {
                    ui.loading.close();
                    vm.termsTitle = result.data.termsTitle;
                    vm.deviceTerms = result.data.deviceTerms;
                    vm.gdprFlag = result.data.gdprFlag;
                    vm.loadingYn = "N";

                    vm.$nextTick(function() {
                        ui.init(); // 2024.06.21 송준형 : REQSDP-5357 - PC Mall 웹접근성 심사결과대응 2차
                        loadLabelledby();
                        if ($('.terms-sec span').length){ $('.terms-sec span').removeAttr('style'); }
                    });
                }).catch((err) => {
                    ui.loading.close();
                    vm.loadingYn = "N";
                    alert("error : " + err);
                });
            }
        },
        computed: {

        },
        mounted() {
            const vm = this;
            $(window).scrollTop(0);
            vm.getDeviceTerms("S_LGN");
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
